const colors = {
  white: "#FFFFFF",
  green: "#7A9565",
  newgreen: "#7A9565",
  darkergreen: "#5A784F",
  lightergreen: "#B8B889",
  beige: "#F8F5F3",
  black: "#1D1D1D",
  borderGrey: "#EBEBEB",
  grey: "#666666",
  newGrey: "#222222",
  newLightGrey: "#555555",
  newMediumGrey: "#454545",
  greyDark: "#2B2928",
  greyBorders: "#333333",
  greyPlaceHolder: "#999999",
  greyPDP: "#A2A2A2",
  mediumGrey: "#444444",
  newBorderGrey: "#DBDBDB",
  textGrey: "#454545",
  mediumTextGrey: "#2D2D2D",
  red: "#BD3B2E",
  yellow: "#FFB450",
  pink: "#DFC6C6",
  lightgreen: "#C5D6DB",
  newGreyLight: "#ECECEC",
  secondaryBeige: "#D1C1B6",
  secondaryBeigeLight: "rgba(209, 193, 182, 0.25);",
  secondaryBeigeMedium: "#D1C1B680",
  darkBeige: "#D8CDC6",
  newbeige: "#F4F0E7",
  trueBlack: "#000000",
  lightGreen: "#87A198",
  newTextGrey: "#B3B3B3",
  errorRed: "#E73434",
  mediumDarkGrey: "#979797",
  borderLightGrey: "#CCCCCC",
  darkergreen: "#5A784F",
  newbeige: "#F4F0E7",
  newLightGreen: "#7A9565",
  globalgreen: "#B8B889",
}

export default colors
